import React, { useEffect, useState } from "react";
import "./BannerCarousel.css";

const BannerCarousel = ({ banners = [], interval = 5000 }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (banners.length <= 1) return;

    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % banners.length);
    }, interval);

    return () => clearInterval(timer);
  }, [banners.length, interval]);

  if (!banners || banners.length === 0) return null;

  return (
    <div className="banner_carousel">
      {banners.map((banner, index) => {
        const mediaUrl = process.env.REACT_APP_IMAGE_URL + banner.image;
        const isVideo = /\.(mp4|webm|ogg)$/i.test(banner.image || "");

        return (
          <div
            key={banner.id || index}
            className={`banner_carousel_slide ${
              index === activeIndex ? "active" : ""
            }`}
          >
          {isVideo ? (
  <video
    className="banner_carousel_media"
    src={mediaUrl}
    autoPlay
    muted
    loop
    playsInline
    onError={(e) =>
      console.error("Video failed to load:", mediaUrl, e.target.error)
    }
  />
) : (
              <img
                className="banner_carousel_media"
                src={mediaUrl}
                alt={banner.name || "Banner"}
              />
            )}
            {banner.name && (
              <p className="banner_carousel_title">{banner.name}</p>
            )}
          </div>
        );
      })}

      {banners.length > 1 && (
        <div className="banner_carousel_dots">
          {banners.map((_, index) => (
            <span
              key={index}
              className={`banner_carousel_dot ${
                index === activeIndex ? "active" : ""
              }`}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BannerCarousel;